import React from 'react';

import {MuiThemeProvider} from "@material-ui/core/styles";
import {Button, Card, CardActions, CardContent, Grid, TextField} from "@material-ui/core";
import AppLogo from "./AppLogo";
import SystemMessageSnackbar from "./SystemMessageSnackbar";

class Login extends React.Component {

    constructor(props) {
        console.log("Login.constructor")
        super(props)
    }

    render() {
        return (
            <MuiThemeProvider theme={this.props.theme}>
                <Grid
                    container
                    spacing={24}
                    style={{
                        margin: 0,
                        width: '100%'
                    }}
                >
                    <Grid item xs />
                    <Grid item xs={10} sm={6} md={4}>
                        <AppLogo />
                        <Card>
                            <form
                                id="cookn-app-login"
                                method="post"
                                onSubmit={e => {
                                    this.props.login(e)
                                }}
                            >
                                <h2 id="login__header">Cook'n Web App Login</h2>
                                <CardContent>
                                    <TextField
                                        id="user-email"
                                        name="userEmail"
                                        label="Email Address"
                                        type="email"
                                        margin="normal"
                                        fullWidth
                                        required
                                        onChange={this.props.loginFormChangeHandler}
                                    />
                                    <TextField
                                        id="user-password"
                                        name="userPassword"
                                        label="Password"
                                        type="password"
                                        margin="normal"
                                        fullWidth
                                        required
                                        onChange={this.props.loginFormChangeHandler}
                                    />
                                    <p>
                                        <a
                                            className="link-function"
                                            onClick={e => {
                                                this.props.forgotPassword(e)
                                            }}
                                        >
                                            Reset My Password
                                        </a>
                                    </p>
                                </CardContent>
                                <CardActions style={{ justifyContent: 'center' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        Log In
                                    </Button>
                                    <Button
                                        id="button--create-account"
                                        variant="contained"
                                        color="default"
                                        type="button"
                                        onClick={e => {
                                            this.props.createAccountHandler(e)
                                        }}
                                    >
                                        Create Account
                                    </Button>
                                </CardActions>
                            </form>
                        </Card>
                    </Grid>
                    <Grid item xs />
                </Grid>
                {this.SocialLogins()}
            </MuiThemeProvider>
        )
    }

    SocialLogins() {
        return (
            <div>
                <style id={"social_logins_iframe_style"}>
                    {`
                        #social_logins_iframe {
                            height: 165px;
                        }                     
                    `}
                </style>
                <iframe id={"social_logins_iframe"}
                        src={"https://www.dvo.com/auth/views/social-logins.php?iframe=t&pfm=web"}
                        style={{
                            width: "100%",
                            marginTop: "10px",
                            border: "none",
                            overflow: "hidden"
                        }}
                        onLoad={(event) => {
                            // TODO - Tyler to check the following code, which is disabled due to causing errors
                            // this.setSocialLoginsHeight(event)
                        }}>
                </iframe>
            </div>
        )
    }

    setSocialLoginsHeight = (event) => {
        const frameDoc = event.target.contentDocument;
        const frameBody = frameDoc.body;
        const frameHtml = frameDoc.documentElement;
        const height = Math.max( frameBody.scrollHeight, frameBody.offsetHeight,
            frameHtml.clientHeight, frameHtml.scrollHeight, frameHtml.offsetHeight );
        console.log("Dynamic Height: [" + height + "]");
        document.getElementById("social_logins_iframe_style").sheet.cssRules[0].style.height = height + "px";
    }
}

export default Login



// WEBPACK FOOTER //
// ./src/Components/Login.js